<template>
  <div class="contract-modal">
    <v-dialog
      v-model="isVisible"
      max-width="566"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title
          class="contract-modal__title headline"
          primary-title
        >
          EMPLOYMENT INFORMATIONS
          <v-btn icon large color="primary" @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <div class="contract-details">
            <div class="contract-details__icon">
              <img src="@/assets/img/icon-project-details.svg" alt="Bench time icon">
            </div>
            <div class="contract-details__wrapper">
              <label class="contract-details__label">Contract</label>
              <p class="contract-details__data">
                {{ currentContract.start_date | displayDate }}
                -
                {{ currentContract.end_date | displayDate }}
              </p>
            </div>
          </div>

          <div class="contract-details">
            <div class="contract-details__icon">
              <img src="@/assets/img/icon-team-members.svg" alt="Bench finance icon">
            </div>
            <div class="contract-details__wrapper">
              <label class="contract-details__label">Hourly rate for the Customer</label>
              <p class="contract-details__data">
                {{ currentContract.client_rate }} PLN / h
              </p>
            </div>
          </div>

          <div class="contract-details">
            <div class="contract-details__icon">
              <img src="@/assets/img/icon-team-members.svg" alt="Bench finance icon">
            </div>
            <div class="contract-details__wrapper">
              <label class="contract-details__label">Hourly rate for the Developer</label>
              <p class="contract-details__data">
                {{ currentContract.developer_rate }} PLN / h
              </p>
            </div>
          </div>

          <div class="contract-details">
            <div class="contract-details__icon">
              <img src="@/assets/img/icon-team-members.svg" alt="Bench time icon">
            </div>
            <div class="contract-details__wrapper">
              <label class="contract-details__label">Contract notice period</label>
              <p class="contract-details__data">
                {{ currentContract.notice_period }} days
              </p>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    currentContract: {
      type: Object,
      required: false,
    },
  },

  computed: {
    isVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    closeModal() {
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.contract-modal {
  &__title {
    display: flex;
    justify-content: space-between;
    font-weight: 600 !important;
    font-size: 22px !important;
  }
}

.contract-details {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 16px;
  }

  &__icon {
    margin-right: 8px;
    margin-top: 10px;
  }

  &__label {
    font-size: 10px;
    line-height: 12px;
    margin-bottom: 0;
  }
  &__data {
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 0;
    font-weight: 500;
  }
}
</style>
